import { Typography, Box, Chip } from "@mui/material";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import FeedbackDrawer from "../Feedback/FeedbackDrawer";

const Footer = () => {
  const [date, setDate] = useState(new Date());
  const [openDrawer, setOpenDrawer] = useState(false);

  const location = useLocation();

  const openDrawerHandler = (e) => {
    setOpenDrawer(true);
  };

  const closeDrawerHandler = (e) => {
    setOpenDrawer(false);
  };
  const showFeedback = () => {
    if (location.pathname === "/serverless-computing") {
      return true;
    }

    return false;
  };
  return (
    <Box>
      {openDrawer && (
        <FeedbackDrawer open={openDrawer} onClose={closeDrawerHandler} />
      )}
      {showFeedback() && (
        <Box display={"flex"} justifyContent={"flex-end"}>
          <Chip
            sx={{
              marginRight: "2rem",
              marginBottom: "1rem",
              backgroundColor: "#FFC700",
              cursor: "pointer",
              "& .MuiChip-label": { color: "#000" },
            }}
            label="Feedback"
            onClick={openDrawerHandler}
          />
        </Box>
      )}
      <Box
        sx={{
          backgroundColor: "primary.dark",
          height: "80px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography color={"common.white"}>
          {`Copyright © ${date.getFullYear()} Rawdat.AI. All rights reserved.`}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
